<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addShow">新增自有广告</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button v-if="row.status==1" type="warning" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,0)">停用</Button>
					<Button v-if="row.status==0" type="success" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,1)">启用</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addStoreShow" :title="addForm.id?'编辑自有广告':'新增自有广告'">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="广告名称" prop="advertName">
					<Input v-model="addForm.advertName" placeholder="广告名称"></Input>
				</FormItem>
				<FormItem label="标题" prop="title">
					<Input v-model="addForm.title" placeholder="请输入标题"></Input>
				</FormItem>
				<FormItem label="图片">
					<Upload :action="uploadFile" name="file" :on-success="uploadCallback" :default-file-list="fileList"
						:data="uploadData" accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传文件</Button>
					</Upload>
				</FormItem>
				<FormItem label="图片链接" prop="imgUrl">
					<Input v-model="addForm.imgUrl" placeholder="请填写图片链接"></Input>
				</FormItem>
				<FormItem label="跳转链接" prop="linkUrl">
					<Input v-model="addForm.linkUrl" placeholder="请填写跳转链接"></Input>
				</FormItem>
				<FormItem label="类型" prop="type">
					<Select v-model="addForm.type" style="width:200px">
						<Option v-for="item in linkTypes" :value="item.value" :key="item.value">{{ item.name }}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="分享描述" prop="shareDesc">
					<Input v-model="addForm.shareDesc" placeholder="请填写分享描述"></Input>
				</FormItem>

				<FormItem label="状态" prop="status">
					<i-switch v-model="addForm.status" size="large">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateData">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import { LINK_TYPES } from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				linkTypes: LINK_TYPES,
				uploadFile: api.statistics.uploadFile,
				uploadData: { filePath: 'img' },
				fileList: [],
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addStoreShow: false,
				addForm: {
					advertName: '',
					title: '',
					imgUrl: '',
					linkUrl: '',
					type: '',
					shareDesc: '',
					status: true,
				},
				addRule: {
					advertName: [
						{ required: true, message: '请输入广告名称', trigger: 'blur' },
					],
					title: [
						{ required: true, message: '请输入标题', trigger: 'blur' },
					],
					linkUrl: [
						{ required: true, message: '请填写跳转链接', trigger: 'blur' }
					],
					type: [
						{ required: true, message: '请选择类型', trigger: 'blur' }
					],

				}
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '广告名称',
						key: 'advertName',
						align: 'center'
					},
					{
						title: '标题',
						key: 'title',
						align: 'center'
					},
					{
						title: '图片链接',
						key: 'imgUrl',
						align: 'center',
					},
					{
						title: '跳转链接',
						key: 'linkUrl',
						align: 'center',
					},
					{
						title: '类型',
						key: 'type',
						align: 'center'
					},
					{
						title: '分享描述',
						key: 'shareDesc',
						align: 'center'
					},
					{
						title: '状态',
						key: 'status',
						align: 'center',
						render: (h, params) => {
							return h('span', params.row.status == 1 ? '启用' : '停用');
						}

					}, {
						title: '创建日期',
						key: 'createTime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1,
					this.queryData = []
				this.getData()
			},
			getData() {
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize
				}
				api.statistics
					.getInnerAdvertPage(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据列表失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateData() {
				const that = this
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						let params = { ...that.addForm }
						params.status = params.status ? 1 : 0
						api.statistics
							.addOrEditInnerAdvert(params)
							.then(res => {
								that.$Message.success('Success!');
								if (that.addForm.id) {
									//编辑
									that.queryData.forEach(item => {
										if (item.id == that.addForm.id) {
											item.advertName = params.advertName
											item.title = params.title
											item.imgUrl = params.imgUrl
											item.linkUrl = params.linkUrl
											item.type = params.type
											item.shareDesc = params.shareDesc
											item.status = params.status
										}
									})
								} else {
									//新增
									that.refreshData()
								}
								that.addStoreShow = false
							})
							.catch(err => {
								that.$Message.error('新增失败: ' + err.message)
							})

					}
				})
			},

			updateStatus(id, status) {
				const that = this
				api.statistics
					.addOrEditInnerAdvert({ 'id': id, status: status })
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			addShow() {
				this.addForm = {
					advertName: '',
					title: '',
					imgUrl: '',
					linkUrl: '',
					type: '',
					shareDesc: '',
					status: true,
				}
				this.fileList = []
				this.addStoreShow = true
			},
			editData(rowData) {
				this.addForm = {
					id: rowData.id,
					advertName: rowData.advertName,
					title: rowData.title,
					imgUrl: rowData.imgUrl,
					linkUrl: rowData.linkUrl,
					type: rowData.type,
					shareDesc: rowData.shareDesc,
					status: rowData.status == 1 ? true : false
				}
				this.addStoreShow = true

			},
			uploadCallback(response, file, fileList) {
				this.addForm.imgUrl = response.data.url
				this.fileList = [{
					name: response.data.fileName,
					url: response.data.url
				}]
			},

		},



	}
</script>
